export type LanguageCode = 'nl' | 'en' | 'es' | 'fr' | 'ca';

type Language = {
	code: LanguageCode;

	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'es',
		file: 'es.ts',
	},
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'fr',
		file: 'fr.ts',
	},
	{
		code: 'ca',
		file: 'ca.ts',
	},
];
export default languages;
